const HEADERS = {
  'Content-Type': 'application/json',
};

/**
 * Holds the last reCAPTCHA token produced client-side, attached as request
 * header so the backend can verify it server-side.
 */
let recaptchaToken: string | undefined;

export const setRecaptchaToken = (token: string | undefined) => {
  recaptchaToken = token;
};

/**
 * Client mutation to submit a form
 *
 * @async
 * @param {Record<string, string>} formData The form data
 * @returns {Promise}
 */
const submitForm = async (formData: Record<string, unknown>, locale: string) => {
  const response = await fetch('/api/form', {
    method: 'POST',
    body: JSON.stringify(formData),
    headers: {
      ...HEADERS,
      'Accept-Language': locale,
      ...(recaptchaToken ? { 'x-recaptcha-token': recaptchaToken } : {}),
    },
  });

  if (response.status === 200) {
    return response;
  }

  if (response.status === 409) {
    const data = await response.json();
    const error = new Error('Conflict error') as Error & { status: number; conflictData: unknown };

    error.status = 409;
    error.conflictData = data.conflictData;

    throw error;
  }

  throw new Error(`${response.status}: ${response.statusText}`);
};

export { submitForm };
